import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const PAINEL_URL = import.meta.env.VITE_PAINEL_URL || 'https://vagasbrusque.com.br';

/**
 * Rota de callback para sincronizar autenticação entre o painel Livewire e o frontend.
 *
 * Após login no backend, o Livewire redireciona para:
 *   /auth/callback?token=xxx&user={...}&type=candidate|company
 *
 * Este componente salva os dados no localStorage e redireciona para a página desejada.
 */
export default function AuthCallback() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const userParam = searchParams.get('user');
    const type = searchParams.get('type');
    const redirectTo = searchParams.get('redirect') || '/';

    if (token) {
      localStorage.setItem('auth_token', token);

      if (type) {
        localStorage.setItem('user_type', type);
      }

      if (userParam) {
        try {
          // Valida que é JSON válido antes de salvar
          const parsed = JSON.parse(decodeURIComponent(userParam));
          localStorage.setItem('user', JSON.stringify(parsed));
        } catch {
          // Se não conseguir parsear, ignora
        }
      }

      // Redireciona para a página desejada
      window.location.href = redirectTo;
    } else {
      // Sem token — redireciona para login do painel
      window.location.href = `${PAINEL_URL}/login`;
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-600 mx-auto mb-4" />
        <p className="text-gray-500">Autenticando...</p>
      </div>
    </div>
  );
}
